import { Modal } from 'react-bootstrap';

export default function TabsModal({ show }: { show: boolean }) {
  return (
    <Modal
      show={show}
      fullscreen={true}
      backdrop="static"
      keyboard={false}
      className="process-ongoing-modal"
    >
      <Modal.Body className="d-flex flex-column justify-content-center align-items-center h-100">
        <div className="text-center">
          <h2 className="fw-bold mb-3">Process ongoing</h2>
          <p className="mb-0">Our sales team will reach out to share more about this product.</p>
        </div>
      </Modal.Body>
    </Modal>
  );
}
